<template>
  <div class="d-flex flex-column gap-2">
    <h6 class="mb-0">Selecione a categoria que melhor se encaixa com você</h6>
    <v-alert
      v-for="(type, key) in concessionTypes"
      :key="type.id"
      class="text-start mb-0"
      style="cursor: pointer"
      @click="() => (selectedType = key)"
      :color="selectedType == key ? 'primary' : undefined"
      text
      dense
    >
      <v-icon class="float-right">
        {{ selectedType == key ? "mdi-radiobox-marked" : "mdi-radiobox-blank" }}
      </v-icon>
      <h6>
        <!-- <v-icon size="30">{{ type.icon }}</v-icon> -->
        {{ type.name }}
      </h6>
      <span>{{ type.description }}</span>
    </v-alert>
  </div>
</template>

<script>
import concessionTypes from "@/definitions/concessionTypes.json";
export default {
  name: "ConcessionTypeForm",
  emits: ["input"],
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      concessionTypes,
    };
  },
  computed: {
    selectedType: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
